import { Component, contentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { TsDividerComponent } from '../ts-divider';
import { TSIconModule } from '../ts-icon';
import { MatDialogConfig } from '@angular/material/dialog';
import { NgClass } from '@angular/common';

export interface TsBaseDialog<R = unknown> {
  closeDialog: (result?: R) => void;
}

@Component({
  selector: 'ts-dialog',
  standalone: true,
  imports: [TSIconModule, TsDividerComponent, NgClass],
  templateUrl: './ts-dialog.component.html',
  styles: [
    `
      :host {
        .drawer-style {
          &__container {
            @apply flex flex-col;
          }
          &__main {
            @apply flex-1;
          }
        }
      }
    `,
  ],
})
export class TsDialogComponent {
  @Input() title: string = '';
  @Input() suppressHeader = false;
  @Input() showFooter = true;
  @Input() drawerStyle = false;
  @Input() hideCloseButton = false;

  @Output() closeDialog = new EventEmitter<void>();

  readonly headerTemplate = contentChild<TemplateRef<any>>('headerTemplate');

  /**
   * This can be extended to provide different configurations for the dialog
   */
  static getDefaultDialogConfig(): Pick<MatDialogConfig, 'maxWidth' | 'width' | 'restoreFocus'> {
    return {
      maxWidth: '541px',
      width: '100%',
      restoreFocus: false,
    };
  }
}
